import es from '@/i18n/es';
import en from '@/i18n/en';

export default { es, en };
